//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'src/index';

export default {
  methods: {
    openToast() {
      Toast('提示信息');
    },

    openToastWithIcon() {
      Toast({
        message: '操作成功',
        iconClass: 'mintui mintui-success'
      });
    },

    openBottomToast() {
      Toast({
        message: '提示信息',
        position: 'bottom'
      });
    }
  }
};



// WEBPACK FOOTER //
// ./example/pages/toast.vue